(() => {

  if (!window.location.pathname.startsWith('/products/')) {
    console.log('Platamor Cropper: fuera de producto, no se inicia');
    return;
  }

  'use strict';

  const VERSION = '4.3.1';
  const GLOBAL_KEY = '__PLATAMOR_CROPPER__';
  const CROPPER_JS_URL = 'https://cdn.jsdelivr.net/npm/cropperjs@1.6.2/dist/cropper.min.js';
  const CROPPER_CSS_URL = 'https://cdn.jsdelivr.net/npm/cropperjs@1.6.2/dist/cropper.min.css';
  const OUTPUT_SIZE = 1400;
  const OUTPUT_QUALITY = 0.92;

  const PRODUCT_CONFIGS = {
    relicario: {
      key: 'relicario',
      handles: [
        'relicario-corazon-personalizado',
        'relicario-love-personalizado-foto-a-color'
      ],
      fieldNames: ['Fotografía 1', 'Fotografía 2'],
      previewTitle: 'Vista previa en el relicario',
      oldPreviewLabel: 'previsualizar relicario',
      assets: {
        base: 'https://cdn.shopify.com/s/files/1/0747/8892/9732/files/Relicario_corazon.png?v=1783695634',
        masks: [
          'https://cdn.shopify.com/s/files/1/0747/8892/9732/files/platamor_mask_left.png?v=1783697969',
          'https://cdn.shopify.com/s/files/1/0747/8892/9732/files/platamor_mask_right.png?v=1783697937'
        ]
      }
    },

    collar: {
      key: 'collar',
      handles: [
        'collar-corazon-con-foto-grabada-personalizado-platamor'
      ],
      fieldNames: ['Fotografía'],
      previewTitle: 'Vista previa en el collar',
      oldPreviewLabel: 'previsualizar collar',
      assets: {
        gold: 'https://cdn.shopify.com/s/files/1/0747/8892/9732/files/collar-dorado.png?v=1783707661',
        silver: 'https://cdn.shopify.com/s/files/1/0747/8892/9732/files/collar-plata.png?v=1783707661',
        masks: [
          'https://cdn.shopify.com/s/files/1/0747/8892/9732/files/collar_mask_foto.png?v=1783709963'
        ],
        textMask: 'https://cdn.shopify.com/s/files/1/0747/8892/9732/files/collar_mask_texto.png?v=1783709963'
      }
    },

    pulsera: {
      key: 'pulsera',
      handles: [
        'pulsera-eslabones-personalizada'
      ],
      fieldNames: ['Mirada'],
      previewTitle: 'Vista previa en la pulsera',
      oldPreviewLabel: 'previsualizar pulsera',
      cropAspectRatio: 445 / 61,
      outputWidth: 1600,
      assets: {
        base: 'https://cdn.shopify.com/s/files/1/0747/8892/9732/files/Pulcer_personalizada.png?v=1783908157',
        masks: [
          'https://cdn.shopify.com/s/files/1/0747/8892/9732/files/mascara_imagen-pulcera.png?v=1783908157'
        ]
      }
    }
  };

  if (window[GLOBAL_KEY]) {
    return;
  }

  window[GLOBAL_KEY] = {
    version: VERSION
  };

  let cropper = null;
  let activeInput = null;
  let sourceFile = null;
  let sourceUrl = '';
  let fineRotation = 0;
  let previousDocumentOverflow = '';
  let previousBodyOverflow = '';
  let cropperPromise = null;
  let previewFrame = 0;
  let livePreviewUrl = '';
  let previewAssetsPromise = null;
  let previewAssets = null;
  let previewAssetsKey = '';

  const previewSources = {
    1: null,
    2: null
  };

  const savedPreviewUrls = {
    1: '',
    2: ''
  };

  const suppressedInputs = new WeakSet();
  const boundInputs = new WeakSet();
  const editButtons = new WeakMap();

  function isProductPage() {
    return /^\/products\/[^/]+/i.test(window.location.pathname);
  }

  function normalizeCatalogText(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function isPlatamorOptionField(element) {
    if (
      !(element instanceof HTMLInputElement) &&
      !(element instanceof HTMLTextAreaElement) &&
      !(element instanceof HTMLSelectElement)
    ) {
      return false;
    }

    const searchableText = normalizeCatalogText([
      element.name,
      element.id,
      element.getAttribute('aria-label'),
      element.getAttribute('placeholder')
    ].filter(Boolean).join(' '));

    return (
      searchableText.includes('fotografia') ||
      searchableText.includes('mirada') ||
      searchableText.includes('link de spotify') ||
      searchableText.includes('spotify') ||
      searchableText.includes('texto para grabar')
    );
  }

  function findCatalogOptionContainer(field) {
    const selectors = [
      '.bold_option',
      '.bold_option_element',
      '.bold_options',
      '.bold_options_loaded',
      '.sc-poptions-option',
      '.sc-poptions-field',
      '.sc-poptions-container',
      '.product-option',
      '.product-form__input',
      '.product-form__field',
      '.form-field',
      'fieldset'
    ];

    for (const selector of selectors) {
      const container = field.closest(selector);

      if (container) {
        return container;
      }
    }

    return field.parentElement;
  }

  function cleanupCatalogProductOptions(root = document) {
    if (isProductPage()) {
      return;
    }

    const scope = root.querySelectorAll
      ? root
      : document;

    scope.querySelectorAll('input, textarea, select').forEach((field) => {
      if (!isPlatamorOptionField(field)) {
        return;
      }

      const container = findCatalogOptionContainer(field);

      if (!container) {
        return;
      }

      /*
       * Solo se oculta el bloque de la opción que contiene el campo.
       * No se toca la tarjeta, imagen, título, precio ni enlaces.
       */
      container.style.setProperty('display', 'none', 'important');
      container.setAttribute('aria-hidden', 'true');
      container.dataset.platamorCatalogHidden = 'true';
    });
  }

  function observeCatalogProductOptions() {
    cleanupCatalogProductOptions(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            cleanupCatalogProductOptions(node);
          }
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function loadStylesheet(href) {
    return new Promise((resolve, reject) => {
      const existing = Array.from(document.querySelectorAll('link[rel="stylesheet"]'))
        .find((link) => link.href === href || link.dataset.platamorCropperCss === 'true');

      if (existing) {
        if (existing.dataset.loaded === 'true' || existing.sheet) {
          resolve();
          return;
        }

        existing.addEventListener('load', resolve, { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.dataset.platamorCropperCss = 'true';
      link.addEventListener('load', () => {
        link.dataset.loaded = 'true';
        resolve();
      }, { once: true });
      link.addEventListener('error', reject, { once: true });
      document.head.appendChild(link);
    });
  }

  function loadScript(src) {
    return new Promise((resolve, reject) => {
      const existing = Array.from(document.scripts)
        .find((script) => script.src === src || script.dataset.platamorCropperJs === 'true');

      if (existing) {
        if (typeof window.Cropper === 'function' || existing.dataset.loaded === 'true') {
          resolve();
          return;
        }

        existing.addEventListener('load', resolve, { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.dataset.platamorCropperJs = 'true';
      script.addEventListener('load', () => {
        script.dataset.loaded = 'true';
        resolve();
      }, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });
  }

  function ensureCropperLoaded() {
    if (typeof window.Cropper === 'function') {
      return Promise.resolve();
    }

    if (!cropperPromise) {
      cropperPromise = Promise.all([
        loadStylesheet(CROPPER_CSS_URL),
        loadScript(CROPPER_JS_URL)
      ]).then(() => {
        if (typeof window.Cropper !== 'function') {
          throw new Error('Cropper.js no quedó disponible.');
        }
      }).catch((error) => {
        cropperPromise = null;
        throw error;
      });
    }

    return cropperPromise;
  }

  function normalizeValue(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function getProductHandle() {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]).toLowerCase() : '';
  }

  function getCurrentProductConfig() {
    const handle = getProductHandle();

    const exactConfig = Object.values(PRODUCT_CONFIGS).find((config) => {
      return config.handles.some((configuredHandle) => handle === configuredHandle);
    });

    if (exactConfig) {
      return exactConfig;
    }

    /*
     * Respaldo para el relicario: sus dos campos son suficientemente
     * específicos para identificarlo aunque cambie el handle del producto.
     */
    const fileInputs = Array.from(document.querySelectorAll('input[type="file"]'));
    const normalizedNames = fileInputs.map((input) => normalizeValue(input.name));

    const hasPhoto1 = normalizedNames.some((name) => name.includes('fotografia 1'));
    const hasPhoto2 = normalizedNames.some((name) => name.includes('fotografia 2'));

    if (hasPhoto1 && hasPhoto2) {
      return PRODUCT_CONFIGS.relicario;
    }

    return null;
  }

  function detectSelectedMetal() {
    const selectedCandidates = [
      ...document.querySelectorAll(
        'input[type="radio"]:checked, select option:checked, [aria-checked="true"], [data-selected="true"], .is-selected, .selected'
      )
    ];

    const selectedText = normalizeValue(
      selectedCandidates
        .map((element) => [
          element.value,
          element.textContent,
          element.getAttribute('aria-label'),
          element.getAttribute('data-value'),
          element.getAttribute('title')
        ].filter(Boolean).join(' '))
        .join(' ')
    );

    if (
      selectedText.includes('plateado') ||
      selectedText.includes('plata') ||
      selectedText.includes('silver')
    ) {
      return 'silver';
    }

    if (
      selectedText.includes('dorado') ||
      selectedText.includes('oro') ||
      selectedText.includes('gold')
    ) {
      return 'gold';
    }

    const productArea = document.querySelector(
      'product-info, .product-info, .product-form, form[action*="/cart/add"]'
    );

    const productText = normalizeValue(productArea ? productArea.textContent : document.body.textContent);

    if (
      productText.includes('color: plateado') ||
      productText.includes('color plateado') ||
      productText.includes('color: plata')
    ) {
      return 'silver';
    }

    return 'gold';
  }

  function getCropAspectRatio(config) {
    return config && config.cropAspectRatio
      ? config.cropAspectRatio
      : 1;
  }

  function getOutputDimensions(config, preview = false) {
    const aspectRatio = getCropAspectRatio(config);
    const width = preview
      ? Math.min(config && config.outputWidth ? config.outputWidth : 700, 900)
      : (config && config.outputWidth ? config.outputWidth : OUTPUT_SIZE);

    return {
      width,
      height: Math.max(1, Math.round(width / aspectRatio))
    };
  }

  function getBaseAssetUrl(config) {
    if (!config) {
      return '';
    }

    if (config.key === 'collar') {
      return detectSelectedMetal() === 'silver'
        ? config.assets.silver
        : config.assets.gold;
    }

    return config.assets.base;
  }

  function resetPreviewAssets() {
    previewAssetsPromise = null;
    previewAssets = null;
    previewAssetsKey = '';
  }

  function createInterface() {
    if (document.getElementById('platamor-cropper-modal')) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'platamor-cropper-styles';
    style.textContent = `
      #platamor-cropper-modal,
      #platamor-cropper-modal * {
        box-sizing: border-box;
      }

      #platamor-cropper-modal {
        display: none;
        position: fixed;
        inset: 0;
        z-index: 2147483000;
        align-items: center;
        justify-content: center;
        padding: 18px;
        overflow-y: auto;
        background: rgba(24, 15, 19, .84);
        -webkit-backdrop-filter: blur(5px);
        backdrop-filter: blur(5px);
      }

      #platamor-cropper-modal.is-open {
        display: flex;
      }

      .platamor-cropper-card {
        position: relative;
        width: 100%;
        max-width: 1120px;
        padding: 26px;
        border-radius: 18px;
        background: linear-gradient(145deg, #ffffff, #fff4f7);
        box-shadow: 0 22px 70px rgba(0, 0, 0, .32);
        text-align: center;
      }

      .platamor-cropper-card h2 {
        margin: 0 44px 6px;
        color: #3f2630;
        font-size: 24px;
        font-weight: 800;
        line-height: 1.25;
      }

      .platamor-cropper-help {
        margin: 0 0 15px;
        color: #786970;
        font-size: 13px;
        line-height: 1.45;
      }

      #platamor-cropper-close {
        position: absolute;
        top: 12px;
        right: 15px;
        z-index: 20;
        width: 38px;
        height: 38px;
        padding: 0;
        border: 0;
        border-radius: 50%;
        background: #ffffff;
        color: #3f2630;
        box-shadow: 0 5px 16px rgba(0, 0, 0, .12);
        font-family: inherit;
        font-size: 30px;
        line-height: 34px;
        cursor: pointer;
      }

      .platamor-cropper-stage {
        width: 100%;
        height: min(58vh, 520px);
        min-height: 320px;
        overflow: hidden;
        border-radius: 14px;
        background: #ece7e9;
      }

      #platamor-cropper-image {
        display: block;
        max-width: 100%;
      }

      .platamor-cropper-controls {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        gap: 10px;
        margin-top: 16px;
      }

      .platamor-cropper-controls button {
        min-width: 48px;
        min-height: 42px;
        padding: 9px 14px;
        border: 1.5px solid #f3a8bf;
        border-radius: 999px;
        background: #ffffff;
        color: #5b303b;
        font-family: inherit;
        font-size: 13px;
        font-weight: 800;
        cursor: pointer;
      }

      #platamor-reset {
        min-width: 116px;
        font-size: 11px;
      }

      .platamor-cropper-fine {
        width: 100%;
        max-width: 470px;
        margin: 14px auto 0;
      }

      .platamor-cropper-fine label {
        display: block;
        margin-bottom: 8px;
        color: #5b303b;
        font-size: 12px;
        font-weight: 800;
      }

      .platamor-rotate-label {
        display: flex !important;
        align-items: center;
        justify-content: space-between;
        gap: 18px;
        width: 100%;
        font-size: 15px !important;
      }

      .platamor-rotate-label span {
        font-size: 22px;
        line-height: 1;
      }

      .platamor-cropper-fine input[type="range"] {
        width: 100%;
        accent-color: #f48fb1;
        cursor: pointer;
      }

      .platamor-cropper-actions {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        margin-top: 18px;
      }

      .platamor-cropper-actions button {
        min-height: 44px;
        padding: 10px 20px;
        border-radius: 999px;
        font-family: inherit;
        font-size: 12px;
        font-weight: 800;
        cursor: pointer;
      }

      #platamor-cropper-cancel {
        border: 1.5px solid #cdbfc4;
        background: #ffffff;
        color: #6f5961;
      }

      #platamor-cropper-confirm {
        border: 1.5px solid #f48fb1;
        background: #f48fb1;
        color: #ffffff;
      }

      #platamor-cropper-confirm:disabled {
        opacity: .55;
        cursor: wait;
      }

      .platamor-cropper-status {
        min-height: 18px;
        margin: 12px 0 0;
        color: #a6294c;
        font-size: 12px;
        font-weight: 700;
      }

      .platamor-edit-photo {
        display: none;
        align-items: center;
        justify-content: center;
        min-height: 38px;
        margin-top: 9px;
        padding: 8px 15px;
        border: 1.5px solid #f48fb1;
        border-radius: 999px;
        background: #ffffff;
        color: #d75783;
        font-family: inherit;
        font-size: 12px;
        font-weight: 800;
        line-height: 1.2;
        cursor: pointer;
      }

      .platamor-edit-photo.is-visible {
        display: inline-flex;
      }


      .platamor-cropper-main {
        display: grid;
        grid-template-columns: minmax(0, 1fr) minmax(300px, 430px);
        gap: 20px;
        align-items: start;
      }

      .platamor-cropper-editor-column,
      .platamor-cropper-preview-column {
        min-width: 0;
      }

      .platamor-cropper-preview-column {
        padding: 14px;
        border: 1px solid rgba(244, 143, 177, .28);
        border-radius: 14px;
        background: #fff;
      }

      .platamor-cropper-preview-title {
        margin: 0 0 10px;
        color: #5b303b;
        font-size: 14px;
        font-weight: 800;
      }

      .platamor-locket-live-stage {
        position: relative;
        width: 100%;
        aspect-ratio: 1 / 1;
        overflow: hidden;
        border-radius: 12px;
        background: linear-gradient(145deg, #fff8fa, #f5eef1);
      }

      #platamor-locket-preview-canvas {
        display: block;
        width: 100%;
        height: 100%;
      }

      .platamor-cropper-preview-note {
        margin: 10px 0 0;
        color: #786970;
        font-size: 11px;
        line-height: 1.4;
      }



      /* Estilo estable para los campos de fotografía de SC Product Options */
      input[type="file"][name*="Fotografía"],
      input[type="file"][name*="Fotografia"],
      input[type="file"][name*="Mirada"] {
        width: 100% !important;
        min-height: 58px !important;
        padding: 8px 12px !important;
        border: 2px solid #f3a2bf !important;
        border-radius: 18px !important;
        background: #fffafd !important;
        color: #6c3342 !important;
        -webkit-text-fill-color: #6c3342 !important;
        font: inherit !important;
        font-size: 14px !important;
        line-height: 1.25 !important;
        opacity: 1 !important;
        cursor: pointer !important;
        overflow: hidden !important;
      }

      input[type="file"][name*="Fotografía"]::file-selector-button,
      input[type="file"][name*="Fotografia"]::file-selector-button,
      input[type="file"][name*="Mirada"]::file-selector-button,
      input[type="file"][name*="Fotografía"]::-webkit-file-upload-button,
      input[type="file"][name*="Fotografia"]::-webkit-file-upload-button,
      input[type="file"][name*="Mirada"]::-webkit-file-upload-button {
        min-height: 42px !important;
        margin: 0 14px 0 0 !important;
        padding: 10px 22px !important;
        border: 0 !important;
        border-radius: 12px !important;
        background: #ef80aa !important;
        color: #ffffff !important;
        -webkit-text-fill-color: #ffffff !important;
        font: inherit !important;
        font-size: 14px !important;
        font-weight: 800 !important;
        letter-spacing: .01em !important;
        cursor: pointer !important;
      }

      input[type="file"][name*="Fotografía"]:hover::file-selector-button,
      input[type="file"][name*="Fotografia"]:hover::file-selector-button,
      input[type="file"][name*="Mirada"]:hover::file-selector-button,
      input[type="file"][name*="Fotografía"]:hover::-webkit-file-upload-button,
      input[type="file"][name*="Fotografia"]:hover::-webkit-file-upload-button,
      input[type="file"][name*="Mirada"]:hover::-webkit-file-upload-button {
        background: #e96f9d !important;
      }


      /* Forzar los campos de fotografía a ocupar todo el ancho disponible */
      .bold_option:has(input[type="file"][name*="Fotografía"]),
      .bold_option:has(input[type="file"][name*="Fotografia"]),
      .bold_option_element:has(input[type="file"][name*="Fotografía"]),
      .bold_option_element:has(input[type="file"][name*="Fotografia"]),
      .sc-poptions-option:has(input[type="file"][name*="Fotografía"]),
      .sc-poptions-option:has(input[type="file"][name*="Fotografia"]),
      .sc-poptions-field:has(input[type="file"][name*="Fotografía"]),
      .sc-poptions-field:has(input[type="file"][name*="Fotografia"]),
      .product-option:has(input[type="file"][name*="Fotografía"]),
      .product-option:has(input[type="file"][name*="Fotografia"]),
      .form-field:has(input[type="file"][name*="Fotografía"]),
      .form-field:has(input[type="file"][name*="Fotografia"]),
      .bold_option:has(input[type="file"][name*="Mirada"]),
      .bold_option_element:has(input[type="file"][name*="Mirada"]),
      .sc-poptions-option:has(input[type="file"][name*="Mirada"]),
      .sc-poptions-field:has(input[type="file"][name*="Mirada"]),
      .product-option:has(input[type="file"][name*="Mirada"]),
      .form-field:has(input[type="file"][name*="Mirada"]) {
        display: block !important;
        width: 100% !important;
        max-width: none !important;
        min-width: 0 !important;
        box-sizing: border-box !important;
      }

      input[type="file"][name*="Fotografía"],
      input[type="file"][name*="Fotografia"],
      input[type="file"][name*="Mirada"] {
        display: block !important;
        width: 100% !important;
        max-width: none !important;
        min-width: 0 !important;
        box-sizing: border-box !important;
      }


      /* Campos de la pulsera al mismo ancho que Mirada */
      body:has(input[type="file"][name*="Mirada"])
      input[name*="Link de Spotify"],
      body:has(input[type="file"][name*="Mirada"])
      input[name*="Spotify"],
      body:has(input[type="file"][name*="Mirada"])
      textarea[name*="Link de Spotify"],
      body:has(input[type="file"][name*="Mirada"])
      textarea[name*="Spotify"],
      body:has(input[type="file"][name*="Mirada"])
      input[name*="Texto"],
      body:has(input[type="file"][name*="Mirada"])
      textarea[name*="Texto"] {
        display: block !important;
        width: 100% !important;
        max-width: none !important;
        min-width: 0 !important;
        box-sizing: border-box !important;
      }

      body:has(input[type="file"][name*="Mirada"])
      .bold_option:has(input[name*="Link de Spotify"]),
      body:has(input[type="file"][name*="Mirada"])
      .bold_option:has(input[name*="Spotify"]),
      body:has(input[type="file"][name*="Mirada"])
      .bold_option:has(textarea[name*="Link de Spotify"]),
      body:has(input[type="file"][name*="Mirada"])
      .bold_option:has(textarea[name*="Spotify"]),
      body:has(input[type="file"][name*="Mirada"])
      .bold_option:has(input[name*="Texto"]),
      body:has(input[type="file"][name*="Mirada"])
      .bold_option:has(textarea[name*="Texto"]),
      body:has(input[type="file"][name*="Mirada"])
      .bold_option_element:has(input[name*="Link de Spotify"]),
      body:has(input[type="file"][name*="Mirada"])
      .bold_option_element:has(input[name*="Spotify"]),
      body:has(input[type="file"][name*="Mirada"])
      .bold_option_element:has(textarea[name*="Link de Spotify"]),
      body:has(input[type="file"][name*="Mirada"])
      .bold_option_element:has(textarea[name*="Spotify"]),
      body:has(input[type="file"][name*="Mirada"])
      .bold_option_element:has(input[name*="Texto"]),
      body:has(input[type="file"][name*="Mirada"])
      .bold_option_element:has(textarea[name*="Texto"]),
      body:has(input[type="file"][name*="Mirada"])
      .sc-poptions-option:has(input[name*="Link de Spotify"]),
      body:has(input[type="file"][name*="Mirada"])
      .sc-poptions-option:has(input[name*="Spotify"]),
      body:has(input[type="file"][name*="Mirada"])
      .sc-poptions-option:has(textarea[name*="Link de Spotify"]),
      body:has(input[type="file"][name*="Mirada"])
      .sc-poptions-option:has(textarea[name*="Spotify"]),
      body:has(input[type="file"][name*="Mirada"])
      .sc-poptions-option:has(input[name*="Texto"]),
      body:has(input[type="file"][name*="Mirada"])
      .sc-poptions-option:has(textarea[name*="Texto"]),
      body:has(input[type="file"][name*="Mirada"])
      .sc-poptions-field:has(input[name*="Link de Spotify"]),
      body:has(input[type="file"][name*="Mirada"])
      .sc-poptions-field:has(input[name*="Spotify"]),
      body:has(input[type="file"][name*="Mirada"])
      .sc-poptions-field:has(textarea[name*="Link de Spotify"]),
      body:has(input[type="file"][name*="Mirada"])
      .sc-poptions-field:has(textarea[name*="Spotify"]),
      body:has(input[type="file"][name*="Mirada"])
      .sc-poptions-field:has(input[name*="Texto"]),
      body:has(input[type="file"][name*="Mirada"])
      .sc-poptions-field:has(textarea[name*="Texto"]) {
        display: block !important;
        width: 100% !important;
        max-width: none !important;
        min-width: 0 !important;
        box-sizing: border-box !important;
      }

      /* Número visible en el selector de cantidad del tema Canyon */
      quantity-selector input[name="quantity"],
      .quantity-selector input[name="quantity"],
      .quantity__input,
      input[name="quantity"].quantity-selector__input,
      .product-form input[name="quantity"] {
        display: block !important;
        position: static !important;
        flex: 0 0 44px !important;
        width: 44px !important;
        min-width: 44px !important;
        height: auto !important;
        margin: 0 !important;
        padding: 0 !important;
        border: 0 !important;
        background: transparent !important;
        color: #5b0f16 !important;
        -webkit-text-fill-color: #5b0f16 !important;
        opacity: 1 !important;
        visibility: visible !important;
        text-align: center !important;
        font: inherit !important;
        font-weight: 700 !important;
        line-height: 1 !important;
        pointer-events: auto !important;
        appearance: textfield !important;
        -moz-appearance: textfield !important;
      }

      quantity-selector input[name="quantity"]::-webkit-outer-spin-button,
      quantity-selector input[name="quantity"]::-webkit-inner-spin-button,
      .quantity-selector input[name="quantity"]::-webkit-outer-spin-button,
      .quantity-selector input[name="quantity"]::-webkit-inner-spin-button,
      .quantity__input::-webkit-outer-spin-button,
      .quantity__input::-webkit-inner-spin-button {
        margin: 0 !important;
        -webkit-appearance: none !important;
      }

      @media (max-width: 900px) {
        .platamor-cropper-main {
          grid-template-columns: 1fr;
        }

        .platamor-cropper-preview-column {
          max-width: 430px;
          margin: 0 auto;
          width: 100%;
        }
      }

      @media (max-width: 749px) {
        #platamor-cropper-modal {
          align-items: flex-start;
          padding: 8px;
        }

        .platamor-cropper-card {
          margin: 8px 0;
          padding: 20px 10px;
          border-radius: 15px;
        }

        .platamor-cropper-card h2 {
          font-size: 19px;
        }

        .platamor-cropper-stage {
          height: 52vh;
          min-height: 280px;
        }

        .platamor-cropper-controls {
          gap: 7px;
        }

        .platamor-cropper-controls button {
          padding: 8px 11px;
          font-size: 12px;
        }

        #platamor-reset {
          min-width: 104px;
        }

        .platamor-cropper-actions {
          gap: 8px;
        }

        .platamor-cropper-actions button {
          padding: 10px 15px;
        }
      }
    `;

    const modal = document.createElement('div');
    modal.id = 'platamor-cropper-modal';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = `
      <div class="platamor-cropper-card" role="dialog" aria-modal="true" aria-labelledby="platamor-cropper-title">
        <button type="button" id="platamor-cropper-close" aria-label="Cerrar">×</button>

        <h2 id="platamor-cropper-title">Ajusta tu fotografía</h2>
        <p class="platamor-cropper-help">
          Arrastra la imagen, ajusta el zoom y gírala hasta que quede como quieres.
        </p>

        <div class="platamor-cropper-main">
          <div class="platamor-cropper-editor-column">
            <div class="platamor-cropper-stage">
              <img id="platamor-cropper-image" alt="Fotografía para ajustar">
            </div>

            <div class="platamor-cropper-controls">
              <button type="button" id="platamor-zoom-out" aria-label="Alejar">−</button>
              <button type="button" id="platamor-reset">RESTABLECER</button>
              <button type="button" id="platamor-zoom-in" aria-label="Acercar">+</button>
            </div>

            <div class="platamor-cropper-fine">
              <label for="platamor-rotate-range" class="platamor-rotate-label">
                <span aria-hidden="true">↺</span>
                <strong>GIRAR</strong>
                <span aria-hidden="true">↻</span>
              </label>
              <input id="platamor-rotate-range" type="range" min="-20" max="20" step="1" value="0">
            </div>
          </div>

          <div class="platamor-cropper-preview-column">
            <p class="platamor-cropper-preview-title" id="platamor-preview-title">Vista previa</p>

            <div class="platamor-locket-live-stage">
              <canvas
                id="platamor-locket-preview-canvas"
                width="1200"
                height="1200"
                aria-label="Vista previa del producto"
              ></canvas>
            </div>

            <p class="platamor-cropper-preview-note">
              La vista previa se actualiza mientras mueves, acercas o giras la fotografía.
            </p>
          </div>
        </div>

        <p class="platamor-cropper-status" id="platamor-cropper-status" aria-live="polite"></p>

        <div class="platamor-cropper-actions">
          <button type="button" id="platamor-cropper-cancel">CANCELAR</button>
          <button type="button" id="platamor-cropper-confirm">USAR ESTA FOTO</button>
        </div>
      </div>
    `;

    document.head.appendChild(style);
    document.body.appendChild(modal);
  }

  function getUi() {
    const modal = document.getElementById('platamor-cropper-modal');

    return {
      modal,
      image: modal.querySelector('#platamor-cropper-image'),
      closeButton: modal.querySelector('#platamor-cropper-close'),
      cancelButton: modal.querySelector('#platamor-cropper-cancel'),
      confirmButton: modal.querySelector('#platamor-cropper-confirm'),
      zoomOutButton: modal.querySelector('#platamor-zoom-out'),
      zoomInButton: modal.querySelector('#platamor-zoom-in'),
      resetButton: modal.querySelector('#platamor-reset'),
      rotateRange: modal.querySelector('#platamor-rotate-range'),
      status: modal.querySelector('#platamor-cropper-status'),
      previewTitle: modal.querySelector('#platamor-preview-title'),
      previewCanvas: modal.querySelector('#platamor-locket-preview-canvas')
    };
  }

  function revokePreviewUrl(url) {
    if (url) {
      URL.revokeObjectURL(url);
    }
  }

  function clearLivePreviewUrl() {
    if (livePreviewUrl) {
      revokePreviewUrl(livePreviewUrl);
      livePreviewUrl = '';
    }
  }

  function getFieldIndex(input) {
    return getFieldNumber(input) === '2' ? 2 : 1;
  }

  function loadImage(url) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.crossOrigin = 'anonymous';
      image.onload = () => resolve(image);
      image.onerror = () => reject(new Error(`No se pudo cargar: ${url}`));
      image.src = url;
    });
  }

  function getMaskBounds(maskImage, width, height) {
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;

    const context = canvas.getContext('2d', { willReadFrequently: true });
    context.clearRect(0, 0, width, height);
    context.drawImage(maskImage, 0, 0, width, height);

    const pixels = context.getImageData(0, 0, width, height).data;

    let minX = width;
    let minY = height;
    let maxX = -1;
    let maxY = -1;

    for (let y = 0; y < height; y += 1) {
      for (let x = 0; x < width; x += 1) {
        const alpha = pixels[((y * width) + x) * 4 + 3];

        if (alpha > 15) {
          minX = Math.min(minX, x);
          minY = Math.min(minY, y);
          maxX = Math.max(maxX, x);
          maxY = Math.max(maxY, y);
        }
      }
    }

    if (maxX < minX || maxY < minY) {
      return {
        x: 0,
        y: 0,
        width,
        height
      };
    }

    return {
      x: minX,
      y: minY,
      width: maxX - minX + 1,
      height: maxY - minY + 1
    };
  }

  function ensurePreviewAssets() {
    const config = getCurrentProductConfig();

    if (!config) {
      return Promise.reject(new Error('Este producto no tiene configuración de vista previa.'));
    }

    const baseUrl = getBaseAssetUrl(config);
    const assetKey = `${config.key}:${baseUrl}`;

    if (previewAssets && previewAssetsKey === assetKey) {
      return Promise.resolve(previewAssets);
    }

    if (previewAssetsPromise && previewAssetsKey === assetKey) {
      return previewAssetsPromise;
    }

    previewAssetsKey = assetKey;

    previewAssetsPromise = Promise.all([
      loadImage(baseUrl),
      ...config.assets.masks.map((maskUrl) => loadImage(maskUrl))
    ]).then(([base, ...masks]) => {
      const width = base.naturalWidth || base.width;
      const height = base.naturalHeight || base.height;

      previewAssets = {
        config,
        base,
        masks,
        bounds: masks.map((mask) => getMaskBounds(mask, width, height)),
        width,
        height
      };

      return previewAssets;
    }).catch((error) => {
      resetPreviewAssets();
      throw error;
    });

    return previewAssetsPromise;
  }

  function fileToImage(file) {
    return new Promise((resolve, reject) => {
      const url = URL.createObjectURL(file);
      const image = new Image();

      image.onload = () => {
        URL.revokeObjectURL(url);
        resolve(image);
      };

      image.onerror = () => {
        URL.revokeObjectURL(url);
        reject(new Error('No se pudo leer la fotografía seleccionada.'));
      };

      image.src = url;
    });
  }

  function drawPhotoThroughMask(
    context,
    sourceImage,
    maskImage,
    bounds,
    width,
    height,
    grayscale = false
  ) {
    if (!sourceImage) {
      return;
    }

    const layer = document.createElement('canvas');
    layer.width = width;
    layer.height = height;

    const layerContext = layer.getContext('2d');
    layerContext.clearRect(0, 0, width, height);

    const sourceWidth = sourceImage.naturalWidth || sourceImage.width;
    const sourceHeight = sourceImage.naturalHeight || sourceImage.height;

    if (!sourceWidth || !sourceHeight) {
      return;
    }

    const scale = Math.max(
      bounds.width / sourceWidth,
      bounds.height / sourceHeight
    );

    const drawWidth = sourceWidth * scale;
    const drawHeight = sourceHeight * scale;
    const drawX = bounds.x + ((bounds.width - drawWidth) / 2);
    const drawY = bounds.y + ((bounds.height - drawHeight) / 2);

    layerContext.save();

    if (grayscale) {
      layerContext.filter = 'grayscale(1) contrast(1.18)';
    }

    layerContext.drawImage(
      sourceImage,
      drawX,
      drawY,
      drawWidth,
      drawHeight
    );

    layerContext.restore();
    layerContext.globalCompositeOperation = 'destination-in';
    layerContext.drawImage(maskImage, 0, 0, width, height);
    layerContext.globalCompositeOperation = 'source-over';

    context.drawImage(layer, 0, 0);
  }

  function paintProductPreview() {
    const ui = getUi();
    const config = getCurrentProductConfig();

    if (!ui.previewCanvas || !config) {
      return;
    }

    if (ui.previewTitle) {
      ui.previewTitle.textContent = config.previewTitle;
    }

    ensurePreviewAssets().then((assets) => {
      const canvas = ui.previewCanvas;
      const context = canvas.getContext('2d');

      canvas.width = assets.width;
      canvas.height = assets.height;

      context.clearRect(0, 0, assets.width, assets.height);
      context.drawImage(
        assets.base,
        0,
        0,
        assets.width,
        assets.height
      );

      assets.masks.forEach((mask, maskIndex) => {
        const previewIndex = maskIndex + 1;

        drawPhotoThroughMask(
          context,
          previewSources[previewIndex],
          mask,
          assets.bounds[maskIndex],
          assets.width,
          assets.height,
          assets.config.key === 'pulsera'
        );
      });
    }).catch((error) => {
      console.error('Platamor Cropper preview:', error);
    });
  }

  function setPreviewSource(index, sourceImage) {
    previewSources[index] = sourceImage || null;
    paintProductPreview();
  }

  function loadOtherInputPreview() {
    document.querySelectorAll('input[type="file"]').forEach((input) => {
      if (
        !isTargetInput(input) ||
        input === activeInput ||
        !input.files ||
        !input.files[0]
      ) {
        return;
      }

      const index = getFieldIndex(input);

      if (previewSources[index]) {
        return;
      }

      fileToImage(input.files[0]).then((image) => {
        setPreviewSource(index, image);
      }).catch((error) => {
        console.error('Platamor Cropper preview:', error);
      });
    });
  }

  function renderLiveLocketPreview() {
    if (!cropper || !activeInput) {
      return;
    }

    if (previewFrame) {
      cancelAnimationFrame(previewFrame);
    }

    previewFrame = requestAnimationFrame(() => {
      previewFrame = 0;

      if (!cropper || !activeInput) {
        return;
      }

      const config = getCurrentProductConfig();
      const dimensions = getOutputDimensions(config, true);

      const canvas = cropper.getCroppedCanvas({
        width: dimensions.width,
        height: dimensions.height,
        fillColor: '#ffffff',
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'high'
      });

      if (!canvas) {
        return;
      }

      /*
       * El propio canvas recortado se usa como fuente.
       * No se crea un Blob en cada movimiento, por lo que el preview
       * responde más rápido y no hay carreras entre URLs temporales.
       */
      setPreviewSource(getFieldIndex(activeInput), canvas);
    });
  }

  function setStatus(message) {
    const status = document.getElementById('platamor-cropper-status');
    if (status) {
      status.textContent = message || '';
    }
  }

  function destroyCropper() {
    const ui = getUi();

    if (cropper) {
      cropper.destroy();
      cropper = null;
    }

    if (sourceUrl) {
      URL.revokeObjectURL(sourceUrl);
      sourceUrl = '';
    }

    ui.image.onload = null;
    ui.image.onerror = null;
    ui.image.removeAttribute('src');
  }

  function closeEditor() {
    const ui = getUi();

    ui.modal.classList.remove('is-open');
    ui.modal.setAttribute('aria-hidden', 'true');

    document.documentElement.style.overflow = previousDocumentOverflow;
    document.body.style.overflow = previousBodyOverflow;

    destroyCropper();
    clearLivePreviewUrl();

    activeInput = null;
    sourceFile = null;
    fineRotation = 0;
    ui.rotateRange.value = '0';
    ui.confirmButton.disabled = false;
    ui.confirmButton.textContent = 'USAR ESTA FOTO';
    setStatus('');
  }

  function resetRotationControls() {
    const ui = getUi();

    fineRotation = 0;
    ui.rotateRange.value = '0';
  }

  function applyRotation() {
    if (!cropper) {
      return;
    }

    /*
     * Girar no modifica el zoom.
     * La fotografía conserva exactamente el tamaño elegido por el usuario.
     */
    cropper.rotateTo(fineRotation);
    renderLiveLocketPreview();
  }

  function openEditor(file, input) {
    if (!file || !file.type || !file.type.startsWith('image/')) {
      window.alert('Selecciona una imagen válida.');
      return;
    }

    ensureCropperLoaded().then(() => {
      const ui = getUi();

      destroyCropper();

      activeInput = input;
      sourceFile = file;
      resetRotationControls();
      paintProductPreview();
      loadOtherInputPreview();
      setStatus('Cargando fotografía...');

      sourceUrl = URL.createObjectURL(file);

      ui.image.onload = () => {
        cropper = new window.Cropper(ui.image, {
          aspectRatio: getCropAspectRatio(getCurrentProductConfig()),
          viewMode: 1,
          dragMode: 'move',
          autoCropArea: 1,
          responsive: true,
          restore: false,
          checkCrossOrigin: false,
          checkOrientation: true,
          modal: true,
          guides: false,
          center: false,
          highlight: false,
          background: false,
          movable: true,
          rotatable: true,
          scalable: false,
          zoomable: true,
          zoomOnTouch: true,
          zoomOnWheel: true,
          wheelZoomRatio: 0.08,
          cropBoxMovable: false,
          cropBoxResizable: false,
          toggleDragModeOnDblclick: false,
          ready() {
            setStatus('');
            renderLiveLocketPreview();
          },
          crop() {
            renderLiveLocketPreview();
          }
        });
      };

      ui.image.onerror = () => {
        setStatus('No se pudo leer esta fotografía.');
      };

      previousDocumentOverflow = document.documentElement.style.overflow;
      previousBodyOverflow = document.body.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';

      ui.modal.classList.add('is-open');
      ui.modal.setAttribute('aria-hidden', 'false');
      ui.image.src = sourceUrl;
      ui.closeButton.focus();
    }).catch((error) => {
      console.error('Platamor Cropper:', error);
      window.alert('El editor de fotografías no pudo cargar. Recarga la página e inténtalo nuevamente.');
    });
  }

  function createEditedFile(blob) {
    const originalName = sourceFile && sourceFile.name
      ? sourceFile.name
      : 'fotografia';

    const cleanName = originalName.replace(/\.[^.]+$/, '') || 'fotografia';

    return new File(
      [blob],
      `${cleanName}-ajustada.jpg`,
      {
        type: 'image/jpeg',
        lastModified: Date.now()
      }
    );
  }

  function replaceInputFile(input, file) {
    const transfer = new DataTransfer();
    transfer.items.add(file);

    suppressedInputs.add(input);
    input.files = transfer.files;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));

    window.setTimeout(() => {
      suppressedInputs.delete(input);
    }, 0);
  }

  function getFieldNumber(input) {
    const config = getCurrentProductConfig();
    const name = normalizeValue(input.getAttribute('name'));

    if (config && config.key === 'relicario' && name.includes('fotografia 2')) {
      return '2';
    }

    return '1';
  }

  function findOptionContainer(input) {
    const selectors = [
      '.bold_option',
      '.bold_option_element',
      '.sc-poptions-option',
      '.sc-poptions-field',
      '.product-option',
      '.product-form__input',
      '.product-form__field',
      'fieldset',
      '.form-field',
      '.field'
    ];

    for (const selector of selectors) {
      const container = input.closest(selector);
      if (container) {
        return container;
      }
    }

    return input.parentElement;
  }

  function updateEditButton(input) {
    if (!input || !input.isConnected) {
      return;
    }

    let button = editButtons.get(input);

    if (!button || !button.isConnected) {
      const container = findOptionContainer(input);

      if (!container) {
        return;
      }

      button = document.createElement('button');
      button.type = 'button';
      button.className = 'platamor-edit-photo';
      button.dataset.platamorEditPhoto = getFieldNumber(input);
      button.textContent = 'Editar fotografía';

      button.addEventListener('click', () => {
        const file = input.files && input.files[0];

        if (!file) {
          window.alert('Primero selecciona una fotografía.');
          return;
        }

        openEditor(file, input);
      });

      container.appendChild(button);
      editButtons.set(input, button);
    }

    const hasFile = Boolean(input.files && input.files[0]);
    button.classList.toggle('is-visible', hasFile);
    button.disabled = !hasFile;
  }

  function isTargetInput(input) {
    if (!(input instanceof HTMLInputElement) || input.type !== 'file') {
      return false;
    }

    const config = getCurrentProductConfig();

    if (!config) {
      return false;
    }

    const normalizedName = normalizeValue(input.getAttribute('name'));

    return config.fieldNames.some((fieldName) => {
      return normalizedName.includes(normalizeValue(fieldName));
    });
  }

  function bindInput(input) {
    if (!isTargetInput(input) || boundInputs.has(input)) {
      return;
    }

    boundInputs.add(input);

    input.addEventListener('change', () => {
      updateEditButton(input);

      if (suppressedInputs.has(input)) {
        return;
      }

      const file = input.files && input.files[0];

      if (file) {
        openEditor(file, input);
      }
    });

    updateEditButton(input);
  }

  function connectInputs(root = document) {
    if (root instanceof HTMLInputElement) {
      bindInput(root);
      return;
    }

    if (!root.querySelectorAll) {
      return;
    }

    root.querySelectorAll('input[type="file"]').forEach(bindInput);
  }

  function bindInterfaceEvents() {
    const ui = getUi();

    ui.closeButton.addEventListener('click', closeEditor);
    ui.cancelButton.addEventListener('click', closeEditor);

    ui.zoomOutButton.addEventListener('click', () => {
      if (cropper) {
        cropper.zoom(-0.1);
      }
    });

    ui.zoomInButton.addEventListener('click', () => {
      if (cropper) {
        cropper.zoom(0.1);
      }
    });

    ui.resetButton.addEventListener('click', () => {
      if (!cropper) {
        return;
      }

      cropper.reset();
      resetRotationControls();
      renderLiveLocketPreview();
    });

    ui.rotateRange.addEventListener('input', () => {
      if (!cropper) {
        return;
      }

      fineRotation = Number(ui.rotateRange.value) || 0;
      applyRotation();
    });

    ui.confirmButton.addEventListener('click', () => {
      if (!cropper || !activeInput) {
        return;
      }

      const inputToUpdate = activeInput;

      ui.confirmButton.disabled = true;
      ui.confirmButton.textContent = 'PROCESANDO...';
      setStatus('Preparando fotografía...');

      const config = getCurrentProductConfig();
      const dimensions = getOutputDimensions(config, false);

      const canvas = cropper.getCroppedCanvas({
        width: dimensions.width,
        height: dimensions.height,
        fillColor: '#ffffff',
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'high'
      });

      if (!canvas) {
        ui.confirmButton.disabled = false;
        ui.confirmButton.textContent = 'USAR ESTA FOTO';
        setStatus('No se pudo generar el recorte.');
        return;
      }

      canvas.toBlob((blob) => {
        try {
          if (!blob) {
            throw new Error('No se pudo crear el archivo recortado.');
          }

          const editedFile = createEditedFile(blob);
          const previewIndex = getFieldIndex(inputToUpdate);

          if (savedPreviewUrls[previewIndex]) {
            revokePreviewUrl(savedPreviewUrls[previewIndex]);
          }

          savedPreviewUrls[previewIndex] = URL.createObjectURL(editedFile);

          fileToImage(editedFile).then((image) => {
            setPreviewSource(previewIndex, image);
          }).catch((error) => {
            console.error('Platamor Cropper preview:', error);
          });

          replaceInputFile(inputToUpdate, editedFile);
          closeEditor();
          updateEditButton(inputToUpdate);
        } catch (error) {
          console.error('Platamor Cropper:', error);
          ui.confirmButton.disabled = false;
          ui.confirmButton.textContent = 'USAR ESTA FOTO';
          setStatus('No se pudo guardar la fotografía ajustada.');
        }
      }, 'image/jpeg', OUTPUT_QUALITY);
    });

    ui.modal.addEventListener('click', (event) => {
      if (event.target === ui.modal) {
        closeEditor();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && ui.modal.classList.contains('is-open')) {
        closeEditor();
      }
    });
  }

  function hideCurrentProductLegacyPreviewButton() {
    const config = getCurrentProductConfig();

    if (!config) {
      return;
    }

    const targetInputs = Array.from(document.querySelectorAll('input[type="file"]'))
      .filter(isTargetInput);

    const requiredFieldCount = config.fieldNames.length;

    if (targetInputs.length < requiredFieldCount) {
      return;
    }

    document.querySelectorAll('button, a, [role="button"]').forEach((element) => {
      if (element.closest('#platamor-cropper-modal')) {
        return;
      }

      const label = normalizeValue(element.textContent);

      if (label.includes(config.oldPreviewLabel)) {
        element.style.setProperty('display', 'none', 'important');
        element.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function observeDynamicContent() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            connectInputs(node);
          }
        });
      });

      hideCurrentProductLegacyPreviewButton();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    document.addEventListener('shopify:section:load', (event) => {
      connectInputs(event.target);
    });

    document.addEventListener('shopify:section:reorder', () => {
      connectInputs(document);
    });

    document.addEventListener('change', (event) => {
      const config = getCurrentProductConfig();

      if (!config || config.key !== 'collar') {
        return;
      }

      const target = event.target;

      if (
        target instanceof HTMLInputElement ||
        target instanceof HTMLSelectElement
      ) {
        resetPreviewAssets();
        window.requestAnimationFrame(paintProductPreview);
      }
    });
  }

  ready(() => {
    if (!isProductPage()) {
      observeCatalogProductOptions();
      return;
    }

    createInterface();
    bindInterfaceEvents();
    connectInputs(document);
    hideCurrentProductLegacyPreviewButton();
    observeDynamicContent();

    ensureCropperLoaded().catch((error) => {
      console.error('Platamor Cropper:', error);
    });

    console.info(`Platamor Cropper v${VERSION} cargado`);
  });
})();